import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=7a838195&scoped=true"
import script from "./ClientList.vue?vue&type=script&lang=js"
export * from "./ClientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a838195",
  null
  
)

export default component.exports